@use "styles/abstracts/mixins/common" as m;
@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

.wrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: max-content;
}

.trigger {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 1px solid transparent;
  cursor: pointer;
  padding: 0;
  transition: v.$transition;

  @media (pointer: fine) {
    &:hover {
      border-color: v.$palette-orange-2;
    }
  }
}

.anchor {
  position: fixed;
  z-index: 100;
  pointer-events: none;
}

.dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background-color: v.$palette-white;
  border-radius: 8px;
  box-shadow: v.$shadow2;
  width: max-content;
  pointer-events: auto;

  @include m.media(v.$container-tablet) {
    top: auto;
    bottom: calc(100% + 8px);
    left: 50%;
    transform: translateX(-85%);
  }
}

.label {
  @include t.text(14px, 22px, "semi-bold");
  color: v.$palette-gray-900;
}

.palette {
  display: grid;
  grid-template-columns: repeat(8, 24px);
  gap: 4px;
}

.swatch {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid transparent;
  cursor: pointer;
  padding: 0;
  transition: v.$transition;

  @media (pointer: fine) {
    &:hover {
      border-color: v.$palette-orange-2;
    }
  }

  &.selected {
    border-color: v.$palette-orange-2;
  }
}

.actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.btn {
  padding: 6px 16px;
  @include t.text(12px, 20px, "semi-bold");
  width: 72px;
}
